import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class TransactionInternalTransactions extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default TransactionInternalTransactions
